module.exports = __webpack_public_path__ + "static/media/veneto-village-06.3175d7b7.jpg";